import { Spin } from "antd";

export default function Loader() {
  return (
    <div className="center">
      <Spin size="large" />
    </div>
  );
}
